import Link from 'next/link'

import Box from 'components/atomic/atoms/box'
import { DenoIcon } from 'components/atomic/atoms/icons/logos/deno'
import { FreshIcon } from 'components/atomic/atoms/icons/logos/fresh'
import { KotlinIcon } from 'components/atomic/atoms/icons/logos/kotlin'
import { NextjsIcon } from 'components/atomic/atoms/icons/logos/nextjs'
import { NuxtIcon } from 'components/atomic/atoms/icons/logos/nuxt'
import { QwikIcon } from 'components/atomic/atoms/icons/logos/qwik'
import { ReactIcon } from 'components/atomic/atoms/icons/logos/react'
import { RemixIcon } from 'components/atomic/atoms/icons/logos/remix'
import { SolidjsIcon } from 'components/atomic/atoms/icons/logos/solidjs'
import { SveltekitIcon } from 'components/atomic/atoms/icons/logos/sveltekit'
import { SwiftIcon } from 'components/atomic/atoms/icons/logos/swift'
import { VueIcon } from 'components/atomic/atoms/icons/logos/vue'
import Text from 'components/atomic/atoms/text'
import Card from 'components/atomic/molecules/card'
import { ExamplesIcon } from 'components/pages/@shared/icons/examples'
import { GithubIcon } from 'components/pages/@shared/icons/github'
import { GuidesIcon } from 'components/pages/@shared/icons/guides'
import { QuickstartIcon } from 'components/pages/@shared/icons/quickstart'

const icons = {
  Quickstart: QuickstartIcon,
  Examples: GithubIcon,
  Guides: GuidesIcon,
  Templates: ExamplesIcon,
  'Next.js': NextjsIcon,
  Remix: RemixIcon,
  Nuxt: NuxtIcon,
  Svelte: SveltekitIcon,
  Solid: SolidjsIcon,
  Fresh: FreshIcon,
  Deno: DenoIcon,
  Swift: SwiftIcon,
  Vue: VueIcon,
  Kotlin: KotlinIcon,
  Qwik: QwikIcon,
  React: ReactIcon,
}

const CardGridWidget = (props: {
  items: { title: string; subtitle?: string; href: string }[]
}) => {
  const { items } = props
  return (
    <Box
      data-widget="card-grid"
      grid
      css={{ gridCols: items.length > 1 ? 2 : 1, gap: '$4' }}
    >
      {items.map(({ title, href, subtitle }, index) => (
        <Card.Root
          as={Link}
          key={index}
          href={href}
          {...(href.startsWith('http') && {
            target: '_blank',
            rel: 'noopener',
          })}
          css={{
            display: 'block',
            bgc: '$bg2',
            transition: '.2s ease',
            '&:hover': { border: '1px solid $text2' },
          }}
        >
          <Card.Body css={{ spaceY: 2 }}>
            <Box flex items="center" css={{ spaceX: 2 }}>
              {icons[title] && <Card.Icon icon={icons[title]} />}
              <Text as="p" color="text1" weight="semiBold">
                {title}
              </Text>
            </Box>
            {subtitle && (
              <Text as="p" color="text2" size="sm">
                {subtitle}
              </Text>
            )}
          </Card.Body>
        </Card.Root>
      ))}
    </Box>
  )
}

export default CardGridWidget
